// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2542":"f0e22ec0","6574":"f0e22ec0","9202":"f0e22ec0"}[chunkId] + ".chunk.css";
};